<template>
    <div class="container-fluid">
        <!-- Row 1: Client & Request -->
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="d-block">
                    <span class="form-label">Client</span>
                    <client-ac 
                        v-model="form.CustomerNumber" 
                        inputclass="form-control form-control-sm"
                        placeholder="Search for a client..."
                    ></client-ac>
                </label>
            </div>
            <div class="col-md-6 mb-3">
                <label class="d-block">
                    <span class="form-label">Request/Job</span>
                    <job-ac 
                        v-model="form.RequestId" 
                        :client="form.CustomerNumber"
                        :pm-only="pmOnly"
                        placeholder="Search for a request..."
                    ></job-ac>
                </label>
            </div>
        </div>

        <!-- Row 2: Technician & Date -->
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="d-block">
                    <span class="form-label">Assigned To</span>
                    <tech-ac 
                        v-model="form.TechnicianId" 
                        placeholder="Search for a technician..."
                    ></tech-ac>
                </label>
            </div>
            <div class="col-md-6 mb-3">
                <label class="d-block">
                    <span class="form-label">Date</span>
                    <input
                        type="date" 
                        class="form-control form-control-sm"
                        v-model="form.DateAndTime"
                    />
                </label>
            </div>
        </div>

        <!-- Row 3: Miles & Vehicle -->
        <div class="row">
            <div class="col-md-4 mb-3">
                <label class="d-block">
                    <span class="form-label">Miles</span>
                    <input
                        type="number" 
                        step="0.1"
                        class="form-control form-control-sm"
                        v-model="form.Miles"
                        placeholder="0.0"
                    />
                </label>
            </div>
            <div class="col-md-4 mb-3">
                <kt-select
                    label="Vehicle"
                    :options="vehicles"
                    v-model="form.Vehicle"
                    label-key="label"
                    value-key="value"
                    inputclass="form-control form-control-sm"
                ></kt-select>
            </div>
            <div class="col-md-4 mb-3">
                <kt-select 
                    label="Status"
                    :options="status"
                    placeholder="Select Status"
                    v-model="form.Status"
                    label-key="label"
                    value-key="value"
                    inputclass="form-control form-control-sm"
                ></kt-select>
            </div>
        </div>

        <!-- Row 4: Odometer Start & End -->
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="d-block">
                    <span class="form-label">Odometer Start</span>
                    <input
                        type="number" 
                        class="form-control form-control-sm"
                        v-model="form.OdometerStart"
                        placeholder="Starting odometer reading"
                    />
                </label>
            </div>
            <div class="col-md-6 mb-3">
                <label class="d-block">
                    <span class="form-label">Odometer End</span>
                    <input
                        type="number" 
                        class="form-control form-control-sm"
                        v-model="form.OdometerEnd"
                        placeholder="Ending odometer reading"
                    />
                </label>
            </div>
        </div>

        <!-- Row 5: Reimbursement Date -->
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="d-block">
                    <span class="form-label">Reimbursement Date</span>
                    <input
                        type="date" 
                        class="form-control form-control-sm"
                        v-model="form.ReimbursementDate"
                    />
                </label>
            </div>
        </div>

        <!-- Row 6: Notes (full width) -->
        <div class="row">
            <div class="col-12 mb-3">
                <label class="d-block">
                    <span class="form-label">Notes</span>
                    <textarea
                        class="form-control form-control-sm"
                        rows="4"
                        v-model="form.Notes"
                        placeholder="Mileage notes..."
                    ></textarea>
                </label>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>

import { ref } from "vue";
import attic from "@/services/Attic.js";
import KtSelect from "@/components/UI/KtSelect.vue";
import ClientAc from "@/components/Clients/ClientAc.vue";
import JobAc from "@/components/Jobs/JobAc.vue";
import TechAc from "@/components/Techs/TechAc.vue";

import { MileageModel } from "@/models/MileageModel";

const props = defineProps({
    pmOnly: {
        type: Boolean,
        default: false
    }
});

const form = defineModel({
    type: MileageModel,
    default: new MileageModel()
});

// todo ... load from server
const vehicles = ref(attic.Vehicles);

// todo ... load from server
const status = ref(attic.MileageStatus);

</script>